<template>
  <div class="statement-container">
    <h1 class="statement-title">客戶需知</h1>

    <section
      v-for="(announcement, index) in newAnnouncementData"
      :key="index"
      class="statement-section"
    >
      <h2 v-if="announcement.title">{{ announcement.title }}</h2>
      <pre v-if="announcement.content" v-html="announcement.content"></pre>
    </section>

    <div v-if="!bit && !is_preview" class="agreement-section">
      <b-form-checkbox class="mb-1" v-model="statementData.agree_to_terms">
        本人已完成閱覽及明白內容.
      </b-form-checkbox>
      <b-form-checkbox v-model="statementData.agree_to_promote">
        本人已知悉本需知可在按左上方按鈕後重新查閱.
      </b-form-checkbox>
    </div>

    <div v-if="is_preview" class="d-flex justify-content-end is_preview">
      <b-button variant="primary">接受</b-button>
    </div>

    <div v-else-if="!bit" class="d-flex justify-content-end">
      <b-button variant="primary" @click="onSubmit">接受</b-button>
    </div>
  </div>
</template>

<script>
import {
  BButton,
  BForm,
  BFormInput,
  BFormGroup,
  BCard,
  BLink,
  BCardTitle,
  BCardText,
  BInputGroup,
  BInputGroupAppend,
  BFormCheckbox,
  BOverlay,
  BModal,
} from "bootstrap-vue";
import VuexyLogo from "@core/layouts/components/Logo.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import Ripple from "vue-ripple-directive";
import { $themeConfig } from "@themeConfig";
import store from "@/store";

export default {
  directives: {
    Ripple,
  },
  components: {
    // BSV
    BModal,
    BButton,
    BForm,
    BFormInput,
    BFormGroup,
    BCard,
    BCardTitle,
    BLink,
    VuexyLogo,
    BCardText,
    BInputGroup,
    BInputGroupAppend,
    BFormCheckbox,
    BOverlay,
  },
  props: {
    bit: {
      type: Boolean,
      default: false,
    },
    is_preview: {
      type: Boolean,
      default: false,
    },
    newAnnouncementData: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      statementData: {
        agree_to_terms: false,
        agree_to_promote: false,
      },
      loading: false,
    };
  },
  mounted() {},
  computed: {},
  methods: {
    hide() {
      this.$bvModal.hide("statement-modal");
    },
    makeToast(variant = null, title = null, content = null) {
      this.$bvToast.toast(content, {
        title: title,
        variant,
        solid: true,
      });
    },
    checkVaild() {
      if (!this.statementData.agree_to_terms) {
        // this.makeToast("danger", "Warning", "請先同意以上條款。");
        this.$swal({
          text: "請先同意以上條款。",
          icon: "error",
          confirmButtonText: "確定",
          customClass: {
            confirmButton: "btn btn-primary",
          },
          showClass: {
            popup: "animate__animated animate__bounceIn",
          },
          buttonsStyling: false,
        });
        return false;
      }
      if (!this.statementData.agree_to_promote) {
        // this.makeToast("danger", "Warning", "請先同意接收推廣資訊。");
        this.$swal({
          text: "請先同意接收推廣資訊。",
          icon: "error",
          confirmButtonText: "確定",
          customClass: {
            confirmButton: "btn btn-primary",
          },
          showClass: {
            popup: "animate__animated animate__bounceIn",
          },
          buttonsStyling: false,
        });
        return false;
      }
      return true;
    },
    onSubmit() {
      if (!this.checkVaild()) {
        return;
      }
      // this.$swal({
      //   title: "你確定嗎?",
      //   showCancelButton: true,
      //   confirmButtonText: "提交",
      //   cancelButtonText: "取消",
      //   customClass: {
      //     confirmButton: "btn btn-primary",
      //     cancelButton: "btn btn-outline-danger ml-1",
      //   },
      //   buttonsStyling: false,
      // }).then((result) => {
      //   if (result.value) {
      this.loading = true;

      store
        .dispatch("app/agreeToTerms", this.statementData)
        .then((response) => {
          this.loading = false;
          // this.$swal({
          //   text: response.data.message,
          //   icon: "success",
          //   confirmButtonText: "確定",
          //   customClass: {
          //     confirmButton: "btn btn-primary",
          //   },
          //   showClass: {
          //     popup: "animate__animated animate__bounceIn",
          //   },
          //   buttonsStyling: false,
          // });
          this.hide();
        })
        .catch((error) => {
          this.loading = false;
          this.$swal({
            text: error.response.data.message,
            icon: "error",
            confirmButtonText: "確定",
            customClass: {
              confirmButton: "btn btn-primary",
            },
            showClass: {
              popup: "animate__animated animate__bounceIn",
            },
            buttonsStyling: false,
          });
        });
      //   }
      // });
    },
  },
};
</script>


<style lang="scss">
.statement-container {
  max-width: 800px;
  margin: 0 auto;
  padding: 20px;
  font-family: Arial, sans-serif;
}

.statement-title {
  text-align: center;
  color: #333;
  margin-bottom: 20px;
}

.statement-section {
  margin-bottom: 30px;
  pre {
    margin-bottom: 0;
  }
  h2 {
    color: #2c3e50;
    border-bottom: 2px solid #3498db;
    padding-bottom: 10px;
    margin-bottom: 15px;
    font-size: 20px;
  }

  p,
  ul,
  ol {
    line-height: 1.5;
  }

  pre {
    font-size: 100%;
    * {
      white-space: break-spaces;
    }
    p {
      margin-bottom: 0;
    }
    ul,
    ol {
      margin-bottom: 0;
    }
    ul,
    ul li {
      padding-left: 0.5rem;
      margin-left: 0.5rem;
      list-style-type: disc;
    }
    ol,
    ol li {
      padding-left: 0.5rem;
      margin-left: 0.5rem;
      list-style-type: decimal;
    }
    .ql-align-center{
      text-align: center;
    }
    .ql-align-right{
      text-align: right;
    }
    .ql-align-justify{
      text-align: justify;
    }

    .ql-size-huge {
        font-size: 2.5em;
    }
    .ql-size-large {
      font-size: 1.5em;
    }

    .ql-size-small {
      font-size: 0.75em;
    }
  }

  // ul,
  // ol {
  //   padding-left: 20px;
  // }
}
.agreement-section {
  padding-top: 15px;
  border-top: 2px solid #3498db;
}
</style>